<ion-header class="hidden mobile:flex">
  <ion-toolbar>
    <ion-title>{{ 'Cancellation confirmed' | locale }}</ion-title>
  </ion-toolbar>
</ion-header>
<div class="mobile:hidden mobile:px-6 px-12 pt-6">
  <div class="max-w-screen-lg flex flex-col">
    <h1 class="text-2xl font-sherika-bold">
      {{ 'Cancellation confirmed' | locale }}
    </h1>
    <p class="text-sm text-normal">
      {{ 'Your subscription has been cancelled' | locale }}
    </p>
  </div>
  <hr />
</div>
<ion-content>
  <div class="p-12 mobile:p-4 flex flex-col gap-5">
    <div class="flex flex-col">
      <ion-icon
        name="remove-circle-outline"
        class="text-red-500 text-5xl mb-2"
      ></ion-icon>
      <h2 class="text-lg font-sherika-bold">
        {{ sessionService.fullName() }},
        {{ "We're sorry to see you go!" | locale }}
      </h2>
      <p class="text-normal text-sm mt-1">
        {{ 'Your subscription will expire on ' | locale }}
        {{
          subscriptionService.subscription()?.startDate
            | date: 'longDate'
            | locale
        }}
        {{ '. You can continue using it until then.' | locale }}
      </p>
      <p class="text-normal text-sm">
        {{ 'After ' | locale }}
        {{
          subscriptionService.subscription()?.startDate
            | date: 'longDate'
            | locale
        }}
        {{ 'your pages will be hidden from search results' | locale }}
      </p>
    </div>
    <div></div>
  </div>
</ion-content>
